import { CpCompanyContractInterface } from '../../../interfaces/dto/company-contract/cp-company-contract-interface';

export class CpCompanyContractModel implements CpCompanyContractInterface {
  acEntityId: number = 0;
  address: string = '';
  companyId: number = 0;
  contractResponsiblePersonEmail: string = '';
  contractResponsiblePersonName: string = '';
  contributiveColaboratorPercentageValue: number = 0;
  contributiveFamilyPercentageValue: number = 0;
  contributiveRetiredPercentageValue: number = 0;
  location: string = '';
  name: string = '';
  nif: string = '';
  niss: string = '';
  phoneNumber: string = '';
  postalCode: string = '';

  constructor(init?: Partial<CpCompanyContractModel>) {
    Object.assign(this, init);
  }
}
